module.exports = __webpack_public_path__ + "img/disableconfig.7aa816dd.svg";